import type { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';

export interface FatalErrorProps {
  children: ReactNode;
  titleKey?: IntlKey;
  detailsKey?: IntlKey;
  title?: string;
  details?: string;
}

export const FatalError: FC<FatalErrorProps> = ({ titleKey, title, detailsKey, details, children }) => {
  const { formatMessage } = useIntl();
  return (
    <div className="d-flex justify-content-center flex-column h-100">
      <div className="text-center w-100 m-auto pt-5">
        <div className="display-4">
          <em className="icon icon-lg pb-2 pe-3">warning</em>
          {title ?? (titleKey === undefined ? null : formatMessage({ id: titleKey }))}
        </div>
        <div className="mb-3">{details ?? (detailsKey === undefined ? null : formatMessage({ id: detailsKey }))}</div>
        {children}
      </div>
    </div>
  );
};
